/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ridge_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ridgeline Plot Maker (Joyplot, Free) — Toolverse`)
};

const es_ridge_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador de Gráficos de Cordillera (Joyplot, Gratis) — Toolverse`)
};

const de_ridge_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ridgeline-Plot-Generator (Joyplot, Kostenlos) — Toolverse`)
};

const nl_ridge_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ridgeline Plot Maker (Joyplot, Gratis) — Toolverse`)
};

const fr_ridge_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de graphique en crêtes (Joyplot, gratuit) — Toolverse`)
};

const it_ridge_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di Grafici Ridgeline (Joyplot, Gratis) — Toolverse`)
};

const pt_br2_ridge_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Gráfico Ridgeline (Joyplot, Grátis) — Toolverse`)
};

const pt_ridge_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Gráficos Ridgeline (Joyplot, Grátis) — Toolverse`)
};

const ja_ridge_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リッジラインプロット作成ツール(ジョイプロット・無料) — Toolverse`)
};

const zh_ridge_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`山脊图生成器（Joyplot，免费）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ridge_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ridge_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ridge_meta_title", locale)
	if (locale === "en") return en_ridge_meta_title(inputs)
	if (locale === "es") return es_ridge_meta_title(inputs)
	if (locale === "de") return de_ridge_meta_title(inputs)
	if (locale === "nl") return nl_ridge_meta_title(inputs)
	if (locale === "fr") return fr_ridge_meta_title(inputs)
	if (locale === "it") return it_ridge_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_ridge_meta_title(inputs)
	if (locale === "pt") return pt_ridge_meta_title(inputs)
	if (locale === "ja") return ja_ridge_meta_title(inputs)
	return zh_ridge_meta_title(inputs)
};